import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ApiService} from '../../../services/api.service';
import {NotificationsService} from 'angular2-notifications';
import {ZoomErrorsComponent} from '../zoomView/errors/errors.component';
import {ModalService} from '../../../services/modalService/modal.service';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-errors',
  templateUrl: './errors.component.html',
  styleUrls: ['./errors.component.css', '../myreports.component.css']
})
export class ErrorsComponent implements OnInit {

  ruid: string;
  isLicense: string;
  errors: any = {};
  selectedError: any;

  constructor(private apiService: ApiService,
              private route: ActivatedRoute,
              private notifications: NotificationsService,
              private modalService: ModalService,
              private translate: TranslateService) {
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if (params.ruid) {
        this.ruid = params.ruid;
        const that = this;
        this.apiService.getSummary(this.ruid)
          .subscribe((res) => {
            this.isLicense = res.isLicense;
            if (!res.isLicense) {
              this.apiService.getErrors(this.ruid)
                .subscribe((errorsRes) => {
                  that.errors = errorsRes;
                }, (errorsErr) => {
                    this.notifications.error(this.translate.instant('common.error'), this.apiService.getMessageFromError(errorsErr, this.translate.instant('reports.invalidRuid')));
                });
            }
          }, (error) => {
              this.notifications.error(this.translate.instant('common.error'), this.apiService.getMessageFromError(error, this.translate.instant('reports.invalidRuid')));
          });
      }
    });
  }

  changeSelectedError(error) {
    if (this.selectedError === error) {
      this.selectedError = undefined;
    } else {
      this.selectedError = error;
    }
  }

  zoomView() {
    this.modalService.open(ZoomErrorsComponent, {
        title: this.translate.instant('reports.errorsC.errors'),
        data: {
            errors: this.errors,
            ruid: this.ruid,
            isLicense: this.isLicense
        }
    }).subscribe(model => {
    });
  }

}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/errors/errors.component.ts